import React, { Component } from "react";
import reactCSS from "reactcss";

class Card extends Component {
  state = { hover: false };
  setHover = value => () => this.setState({ hover: value });

  render = () => {
    const styles = reactCSS(
      {
        default: {
          card: {
            backgroundColor: "#FFF",
            transition: "all 0.5s cubic-bezier(.25,.8,.25,1)",
            marginBottom: "20px",
            position: "relative",
            padding: 8
          }
        },
        noMargin: {
          card: {
            margin: 0
          }
        },
        noPadding: {
          card: {
            padding: 0
          }
        },
        shadow: {
          card: {
            backgroundColor: "#FFF",
            boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)"
          }
        },
        hover: {
          card: {
            boxShadow:
              "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)"
          }
        }
      },
      {
        shadow: this.props.shadow,
        hover: this.state.hover && this.props.shadow,
        noMargin: this.props.noMargin,
        noPadding: this.props.noPadding
      }
    );

    const baseStyle = this.props.centered ? { display: "flex" } : {};

    return (
      <div
        className="card"
        style={Object.assign(baseStyle, styles.card, this.props.style)}
        onMouseOver={this.setHover(true)}
        onMouseOut={this.setHover(false)}
        onClick={this.props.onClick}
      >
        <div
          style={{
            alignSelf: this.props.centered ? "center" : "flex-start",
            width: "100%"
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  };
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/support/card/card.js